import { Builder } from '@builder.io/react'
import { Amplify } from 'aws-amplify'
import { getCognitoId, getVisitorId } from 'components/util/UserId'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import LinkRoute from '../../ui/link/Link'

import desktopCurveWave from 'images/navbar-curve-desktop.svg'

//@ts-ignore
import awsconfig from '../../../aws-exports'
Amplify.configure(awsconfig)

import './index.css'

interface Props {
  backgroundColor: string
  logo: any
  showSupportButton: boolean
  showStraightVersion: boolean
}

const StyledHeader = styled.header`
  &::before {
    position: absolute;
    content: '';
    z-index: -1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: ${props => props.backgroundColor};
        ${props =>
          // props.showStraightVersion &&
          `
        -webkit-mask-image: url(${desktopCurveWave});
        -webkit-mask-position: center bottom;
        -webkit-mask-size: 100%;
        -webkit-mask-repeat: no-repeat;
      `}
  }
`

const SimpleHeader = ({ logo, backgroundColor, showSupportButton, showStraightVersion }: Props) => {
  const [_visitorId, setVisitorId] = useState('')
  const [_cognitoId, setCognitoId] = useState('')

  const scrollHandler = () => {
    document.querySelector('#cookiebanner-mask')?.remove()
    document.querySelector('.cookiebanner')?.remove()
  }

  useEffect(() => {
    document.addEventListener('scroll', scrollHandler)

    return () => {
      document.removeEventListener('scroll', scrollHandler)
    }
  }, [])

  useEffect(() => {
    window.onbeforeunload = () => {
      window.scrollTo(0, 0)
    }
  }, [])

  useEffect(() => {
    const callIdsForClarity = async () => {
      setVisitorId(await getVisitorId())
      setCognitoId(await getCognitoId())
    }

    callIdsForClarity()
  }, [])

  return (
    <>
      <div className={'header-wrapper'}>
        <StyledHeader
          backgroundColor={backgroundColor}
          className={`relative mt-0 ${showStraightVersion ? 'min-h-[94px]' : 'min-h-[100px] lg:min-h-[115px]'} lg:block`}
          style={{
            transition: 'top 0.5s',
            top: '-1.7rem',
            transform: 'translateZ(0.1)',
            zIndex: 3
          }}
        >
          <nav
            className="max-w-7 mx-auto"
            style={{ backgroundColor: backgroundColor ? backgroundColor : 'bg-[#F6E9DB]' }}
            aria-label="Top"
          >
            <div className={`flex w-full items-center pt-8 ${showStraightVersion ? 'pb-2' : ''} px-6`}>
              <div className="flex flex-1 items-center justify-between"></div>
              <div className="flex justify-center items-center">
                <LinkRoute href="/">
                  <span className="sr-only">Different Dog</span>
                  <img style={{ width: '200px', maxWidth: '100%' }} src={logo} alt="" />
                </LinkRoute>
              </div>
              <div className="flex flex-1 items-center justify-end">
                {showSupportButton && (
                  <div
                    className={`ml-2 -mr-2 flex cursor-pointer rounded-full p-4 text-sm hover:bg-[white] focus:bg-[white]`}
                    onClick={() => {
                      if (typeof window.zE !== 'undefined') {
                        window.zE('webWidget', 'show')
                        window.zE('webWidget', 'open')
                      } else {
                        window.setTimeout(() => {
                          window.zE('webWidget', 'show')
                          window.zE('webWidget', 'open')
                        }, 1000)
                      }
                    }}
                  >
                    <StaticImage
                      width={30}
                      className="flex flex-shrink-0"
                      src="../../../images/chat.png"
                      alt="Chat with us"
                    />
                  </div>
                )}
              </div>
            </div>
          </nav>
        </StyledHeader>
      </div>
    </>
  )
}

export default SimpleHeader

Builder.registerComponent(SimpleHeader, {
  name: 'SimpleHeader',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'logo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'showSupportButton',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'showStraightVersion',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
